/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingMelcoDigitizingModelsOrderSave
 */
export interface DigitizingMelcoDigitizingModelsOrderSave {
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderSave
     */
    garment_type_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderSave
     */
    position_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderSave
     */
    delivery_option_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderSave
     */
    output_format_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderSave
     */
    width?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderSave
     */
    height?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigitizingMelcoDigitizingModelsOrderSave
     */
    instructions?: string | null;
}

export function DigitizingMelcoDigitizingModelsOrderSaveFromJSON(json: any): DigitizingMelcoDigitizingModelsOrderSave {
    return DigitizingMelcoDigitizingModelsOrderSaveFromJSONTyped(json, false);
}

export function DigitizingMelcoDigitizingModelsOrderSaveFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingMelcoDigitizingModelsOrderSave {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'garment_type_id': !exists(json, 'garment_type_id') ? undefined : json['garment_type_id'],
        'position_id': !exists(json, 'position_id') ? undefined : json['position_id'],
        'delivery_option_id': !exists(json, 'delivery_option_id') ? undefined : json['delivery_option_id'],
        'output_format_id': !exists(json, 'output_format_id') ? undefined : json['output_format_id'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'instructions': !exists(json, 'instructions') ? undefined : json['instructions'],
    };
}

export function DigitizingMelcoDigitizingModelsOrderSaveToJSON(value?: DigitizingMelcoDigitizingModelsOrderSave | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'garment_type_id': value.garment_type_id,
        'position_id': value.position_id,
        'delivery_option_id': value.delivery_option_id,
        'output_format_id': value.output_format_id,
        'width': value.width,
        'height': value.height,
        'instructions': value.instructions,
    };
}


